module.exports = __webpack_public_path__ + "img/a-loading-primary.7f533d8b.svg";